import makeStyles from '@mui/styles/makeStyles'
import Pagination from '@mui/material/Pagination'
import { ROWS_PER_PAGE } from 'lib/constants'
import { buildHref } from 'lib/utils'
import { useRouter } from 'next/router'

const useStyles = makeStyles((theme) => ({
  pagination: {
    clear: 'both',
    marginTop: '40px',
    display: 'flex',
    justifyContent: 'center'
  }
}))

export default function SearchPager ({ total, query }) {
  const classes = useStyles()
  const router = useRouter()

  const page = parseInt(query.page || '1', 10)
  let pages = Math.ceil(total / ROWS_PER_PAGE)
  // Elasticsearch restriction
  pages = Math.min(pages, 10000 / ROWS_PER_PAGE)

  const handleChange = (event, page) => {
    const href = buildHref('/search', query, { page: page === 1 ? null : page })
    router.push(href).then(() => window.scrollTo(0, 0))
  }

  if (pages <= 1) {
    return null
  } else {
    return (
      <div className={classes.pagination}>
        <Pagination
          page={page}
          count={pages}
          variant='outlined'
          color='primary'
          onChange={handleChange}
        />
      </div>
    )
  }
}
